<template>
  <div class="min-w-125px w-auto">
    <div class="d-flex flex-column">
      <div
        class="d-flex justify-content-start p-1 px-2"
      >
        <div class="small">
          {{ dateTime }} <b>{{ moment(comment.updated_at).diff(moment(comment.created_at), 'seconds') > 0 ? '- Edited' : '' }}</b>
        </div>
      </div>

      <b-card
        body-class="py-2 px-2"
        :class="[
          'bg-light border', {
            'border-secondary': String(reply) === String(comment.id)
          }
        ]"
        :style="{
          borderBottomLeftRadius: '24px',
          borderBottomRightRadius: '24px',
          borderTopLeftRadius: '24px',
        }"
      >
        <div
          v-if="repliedComment"
          class="px-2 py-1 mb-2 mx--1 mt--1 cursor-pointer"
          style="border-top-left-radius: 20px; background-color: #f2f2f2;"
          @click.prevent.stop="() => scrollToComment(comment.thread_id)"
        >
          <div
            v-if="Number(repliedComment.commenter_id) === Number(comment.commenter_id)"
            class="font-weight-bold"
          >
            Me
          </div>
          <div
            v-else
            class="font-weight-bold"
          >
            {{ repliedComment?.commenter?.first_name }} {{ repliedComment?.commenter?.last_name }}
          </div>

          <div class="text-truncate">
            {{ repliedComment?.comment }}
          </div>
        </div>

        <div
          v-if="String(reply) === String(comment.id)"
          class="px-2 py-1 mb-2 mx--1 mt--1"
          style="background-color: #f2f2f2;"
          :style="repliedComment ? {} : { borderTopLeftRadius: '20px' }"
        >
          <q>Quoted on Reply</q>
        </div>

        <b-card-text
          v-b-toggle="`collapse-${comment.id}`"
          class="cursor-pointer"
        >
          <div class="d-flex flex-column">
            <div
              class="p-1"
              style="white-space: pre-wrap;"
            >
              {{ comment.comment }}
            </div>
          </div>
        </b-card-text>
      </b-card>

      <b-collapse
        :id="`collapse-${comment.id}`"
      >
        <div class="d-flex gap-2 mt-1 align-items-center justify-content-end px-3">
          <div class="d-flex gap-2">
            <b-button
              size="xs"
              variant="link"
              class="p-0 text-dark"
              :disabled="busy"
              @click.prevent.stop="() => $emit('reply:comment', comment)"
            >
              <i class="ri-reply-line m-0 p-0" /> Reply
            </b-button>

            <b-button
              v-if="restrictEditing"
              size="xs"
              variant="link"
              class="p-0"
              :disabled="busy"
              @click.prevent.stop="() => $emit('edit:comment', comment)"
            >
              <i class="ri-edit-line m-0 p-0" /> Edit
            </b-button>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { find } from 'lodash'

import MxFormatter from '@/mixins/formatter'

export default {
  name: 'MyComment',

  emit: [
    'reply:comment',
    'edit:comment',
    'delete:comment'
  ],

  mixins: [
    MxFormatter
  ],

  props: {
    busy: {
      type: Boolean,
      required: true
    },
    comment: {
      type: Object,
      required: true
    },
    comments: {
      type: Array,
      required: true
    },
    reply: {
      type: [Number, String],
      required: false,
      default: () => ''
    }
  },

  computed: {
    dateTime () {
      const now = moment()
      const createdAt = moment(this.comment.created_at)
      const diffInMinutes = now.diff(createdAt, 'minutes')

      if (diffInMinutes < 1) {
        return 'Just now'
      }

      if (diffInMinutes < 15) {
        return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`
      }

      if (now.isSame(createdAt, 'day')) {
        return `Today at ${createdAt.format('h:mm A')}`
      }

      return createdAt.format('MMMM D, YYYY h:mm A')
    },

    repliedComment () {
      return find(this.comments, {
        id: this.comment.thread_id
      })
    },

    restrictEditing () {
      const now = moment()
      const createdAt = moment(this.comment.created_at)

      return now.diff(createdAt, 'minutes') < 3
    }
  },

  methods: {
    moment: moment,

    scrollToComment (id) {
      const element = document.getElementById(`comment-${id}`)

      const scrollArea = document.getElementById('comment-scroll-area')
      if (scrollArea) {
        scrollArea.scrollTo({
          top: element.offsetTop - 150,
          behavior: 'smooth'
        })

        element.classList.add('animated', 'pulse', 'border', 'border-dark', 'rounded-lg')

        setTimeout(() => {
          element.classList.remove('animated', 'pulse', 'border', 'border-dark', 'rounded-lg')
        }, 1500)
      }
    }
  }
}
</script>
